var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "topbar" }, [
        _c("i", { on: { click: _vm.goIndex } }),
        _vm._v(" "),
        _c("div", { staticClass: "mainBox1 clearfix" }, [
          _c(
            "div",
            {
              staticClass: "changeLangBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.moreLang()
                }
              }
            },
            [
              _vm._v("\n        " + _vm._s(_vm.$t("language")) + "\n        "),
              _c("em", { staticClass: "iconfont icon-een" }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.changeLangBox,
                      expression: "changeLangBox"
                    }
                  ],
                  staticClass: "chooseLangUl"
                },
                _vm._l(_vm.langList, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "chooseLangUlli",
                      on: {
                        click: function($event) {
                          _vm.setLanguage(item.id)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(item.name) + "\n          "
                      )
                    ]
                  )
                })
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "settingBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.setting()
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.name ? _vm.name : _vm.names) +
                  "\n        "
              ),
              _c("em", { staticClass: "iconfont icon-een" }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.settingBoxVis,
                      expression: "settingBoxVis"
                    }
                  ],
                  staticClass: "chooseLangUl chooseLangUls"
                },
                [
                  _c("li", { on: { click: _vm.goIndex } }, [
                    _vm._v(_vm._s(_vm.$t("myHome")))
                  ]),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.toMyAccount } }, [
                    _vm._v(_vm._s(_vm.$t("setting_1")))
                  ]),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.logOut } }, [
                    _vm._v(_vm._s(_vm.$t("setting_2")))
                  ])
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mainBox" }, [
        _c("div", { staticClass: "forgetPsd1" }, [
          _vm._v(_vm._s(_vm.$t("myPageTitle")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "journeyBox" }, [
          _c("div", { staticClass: "tagButtonFlex" }, [
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "tagButton",
                  class: { activeTagButton: _vm.switchFlag == 0 },
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.switchMode(0)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("myJourneyBtn")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tagButton",
                  class: { activeTagButton: _vm.switchFlag == 2 },
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.switchMode(2)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("myLevelMatchBtn")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tagButton",
                  class: { activeTagButton: _vm.switchFlag == 1 },
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.switchMode(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("myGlobalMatchBtn")))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ohcBtn" }, [
              _vm.ohcCert === true && _vm.$i18n.locale === "zh"
                ? _c("img", {
                    attrs: {
                      src: require("@/assets/images/event/oneHourCode/cert-dl-btn-C.png")
                    },
                    on: {
                      click: function($event) {
                        _vm.oneHourCertDownload()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.ohcCert === true && _vm.$i18n.locale !== "zh"
                ? _c("img", {
                    attrs: {
                      src: require("@/assets/images/event/oneHourCode/cert-dl-btn-E.png")
                    },
                    on: {
                      click: function($event) {
                        _vm.oneHourCertDownload()
                      }
                    }
                  })
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.switchFlag == 0
            ? _c(
                "div",
                {
                  staticClass: "bgBox",
                  staticStyle: { width: "100%", height: "auto" }
                },
                [
                  _c(
                    "h1",
                    {
                      class:
                        _vm.scale == "L"
                          ? "myPageh1_L"
                          : _vm.scale == "M"
                          ? "myPageh1_M"
                          : "myPageh1_S"
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("helloWord")) +
                          _vm._s(_vm.names) +
                          _vm._s(_vm.$t("greetWord"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "journeyFlex_L",
                      class:
                        _vm.scale == "L"
                          ? "journeyFlex_L"
                          : _vm.scale == "M"
                          ? "journeyFlex_M"
                          : "journeyFlex_S"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "journeyItem",
                          staticStyle: {
                            "background-image":
                              "url('static/images/myPage_days.png')"
                          },
                          on: {
                            mouseover: function($event) {
                              _vm.mouseHoverIndex = 1
                            },
                            mouseout: function($event) {
                              _vm.mouseHoverIndex = 0
                            }
                          }
                        },
                        [
                          _c("p", { staticClass: "journeyTitle" }, [
                            _vm._v(_vm._s(_vm.$t("Joined ICode")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: _vm.showSignupDate(),
                                placement: "top"
                              }
                            },
                            [
                              _c("p", { staticClass: "journeyNum" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.getDays(_vm.learningData.createTime)
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "journeyFooter" }, [
                            _vm._v(_vm._s(_vm.$t("days ago")))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "journeyItem",
                          staticStyle: {
                            "background-image":
                              "url('static/images/myPage_levels.png')"
                          },
                          on: {
                            mouseover: function($event) {
                              _vm.mouseHoverIndex = 2
                            },
                            mouseout: function($event) {
                              _vm.mouseHoverIndex = 0
                            }
                          }
                        },
                        [
                          _c("p", { staticClass: "journeyTitle" }, [
                            _vm._v(_vm._s(_vm.$t("Completed")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: _vm.showStarData(),
                                placement: "top"
                              }
                            },
                            [
                              _c("p", { staticClass: "journeyNum" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.learningData.oneStarCount +
                                        _vm.learningData.twoStarCount +
                                        _vm.learningData.threeStarCount
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "journeyFooter" }, [
                            _vm._v(_vm._s(_vm.$t("levels")))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "journeyItem",
                          staticStyle: {
                            "background-image":
                              "url('static/images/myPage_competitions.png')"
                          },
                          on: {
                            mouseover: function($event) {
                              _vm.mouseHoverIndex = 3
                            },
                            mouseout: function($event) {
                              _vm.mouseHoverIndex = 0
                            }
                          }
                        },
                        [
                          _c("p", { staticClass: "journeyTitle" }, [
                            _vm._v(_vm._s(_vm.$t("Took part in")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: _vm.showGameData(),
                                placement: "top"
                              }
                            },
                            [
                              _c("p", { staticClass: "journeyNum" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.learningData.monthGameCount +
                                      _vm.learningData.otherGameCount
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "journeyFooter" }, [
                            _vm._v(_vm._s(_vm.$t("competitions")))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "journeyItem",
                          staticStyle: {
                            "background-image":
                              "url('static/images/myPage_awards.png')"
                          },
                          on: {
                            mouseover: function($event) {
                              _vm.mouseHoverIndex = 4
                            },
                            mouseout: function($event) {
                              _vm.mouseHoverIndex = 0
                            }
                          }
                        },
                        [
                          _c("p", { staticClass: "journeyTitle" }, [
                            _vm._v(_vm._s(_vm.$t("Won")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: _vm.showAwardData(),
                                placement: "top"
                              }
                            },
                            [
                              _c("p", { staticClass: "journeyNum" }, [
                                _vm._v(_vm._s(_vm.learningData.totalAwardCount))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "journeyFooter" }, [
                            _vm._v(_vm._s(_vm.$t("awards")))
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "lfooter" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "rfooter" })
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.switchFlag != 0
          ? _c(
              "div",
              { staticClass: "table" },
              [
                _c(
                  "el-table",
                  { staticStyle: { width: "100%" }, attrs: { data: _vm.list } },
                  [
                    _c(
                      "template",
                      { attrs: { slot: "empty" }, slot: "empty" },
                      [
                        _c("span", { staticStyle: { color: "#969696" } }, [
                          _vm._v(_vm._s(_vm.$t("NO DATA")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "gameId",
                        align: "center",
                        label: _vm.$t("competitionName"),
                        formatter: _vm.courseFilter,
                        "show-overflow-tooltip": true,
                        "min-width": "250"
                      }
                    }),
                    _vm._v(" "),
                    _vm.switchFlag == 1
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "awards",
                            align: "center",
                            label: _vm.$t("myAwards"),
                            width: "220"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  scope.row.awardEnd == 1
                                    ? _c("div", [
                                        scope.row.awards &&
                                        scope.row.awards.length != 0
                                          ? _c(
                                              "div",
                                              _vm._l(scope.row.awards, function(
                                                item,
                                                index
                                              ) {
                                                return _c(
                                                  "div",
                                                  { key: index },
                                                  [
                                                    item.prize == 1
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/images/prize1.png"),
                                                            width: "20",
                                                            height: "30",
                                                            alt: ""
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.prize == 2
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/images/prize2.png"),
                                                            width: "20",
                                                            height: "30",
                                                            alt: ""
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.prize == 3
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/images/prize3.png"),
                                                            width: "20",
                                                            height: "30",
                                                            alt: ""
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(item.prizeName)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("el-button", {
                                                      attrs: {
                                                        type: "text",
                                                        icon: "el-icon-document"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.downLoad(
                                                            item,
                                                            scope.row.gameId,
                                                            2,
                                                            scope.row.gameType
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-button", {
                                                      attrs: {
                                                        type: "text",
                                                        icon: "el-icon-download"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.downLoad(
                                                            item,
                                                            scope.row.gameId,
                                                            1,
                                                            scope.row.gameType
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              })
                                            )
                                          : _c("span", [_vm._v("—")])
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("race_unannounced"))
                                        )
                                      ])
                                ]
                              }
                            }
                          ])
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.switchFlag == 2
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "awards",
                            align: "center",
                            label: _vm.$t("myAwards"),
                            width: "220"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  scope.row.awardEnd == 1
                                    ? _c("div", [
                                        scope.row.awards &&
                                        scope.row.awards.length != 0
                                          ? _c(
                                              "div",
                                              _vm._l(scope.row.awards, function(
                                                item,
                                                index
                                              ) {
                                                return _c(
                                                  "div",
                                                  { key: index },
                                                  [
                                                    item.prize != 1 &&
                                                    item.prize != 2 &&
                                                    item.prize != 3
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/images/prizes.png"),
                                                            width: "20",
                                                            height: "30",
                                                            alt: ""
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.prize == 1
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/images/prize1.png"),
                                                            width: "20",
                                                            height: "30",
                                                            alt: ""
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.prize == 2
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/images/prize2.png"),
                                                            width: "20",
                                                            height: "30",
                                                            alt: ""
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.prize == 3
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/images/prize3.png"),
                                                            width: "20",
                                                            height: "30",
                                                            alt: ""
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.prizeFilter(
                                                            item.prize
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("el-button", {
                                                      staticStyle: {
                                                        "margin-left": "10px"
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        icon: "el-icon-document"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.downLoad(
                                                            item,
                                                            scope.row.gameId,
                                                            2,
                                                            scope.row.gameType
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-button", {
                                                      attrs: {
                                                        type: "text",
                                                        icon: "el-icon-download"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.downLoad(
                                                            item,
                                                            scope.row.gameId,
                                                            1,
                                                            scope.row.gameType
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              })
                                            )
                                          : _c("div", [
                                              _vm._v(
                                                _vm._s(_vm.$t("race_noaward"))
                                              )
                                            ])
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("race_unannounced"))
                                        )
                                      ])
                                ]
                              }
                            }
                          ])
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "gameStatus",
                        align: "center",
                        label: _vm.$t("competitionProgress"),
                        width: "160",
                        formatter: _vm.gameFilter
                      }
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "lfooter" }),
                _vm._v(" "),
                _c("div", { staticClass: "rfooter" })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("LeapPopup", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.maskBox,
            expression: "maskBox"
          }
        ],
        attrs: {
          title: _vm.$t("timeout01"),
          content: _vm.$t("timeout02"),
          cancelButtonTxt: _vm.$t("timeout04"),
          okButtonTxt: _vm.$t("timeout03"),
          isConfirm: false
        },
        on: { onOK: _vm.logOut }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.imgShow,
              expression: "imgShow"
            }
          ],
          staticClass: "bgiOver",
          attrs: { id: "mainBox" },
          on: {
            click: function($event) {
              _vm.imgShow = false
            }
          }
        },
        [_c("img", { style: _vm.styleObj, attrs: { alt: "", id: "img" } })]
      ),
      _vm._v(" "),
      _c("div", {
        staticStyle: {
          background: "#fff",
          width: "300px",
          height: "300px",
          display: "none"
        },
        attrs: { id: "qrcode" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78415a2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78415a2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myPage.vue
// module id = null
// module chunks = 